import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Loader2 } from "lucide-react";
import { adminApi } from "../../lib/api";
import { Label, TextInput, Section } from "../FormControls";

const ContactInfo = () => {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { adminApi.contact.get().then(setData); }, []);

  const set = (k, v) => setData((d) => ({ ...d, [k]: v }));
  const setSocial = (k, v) => setData((d) => ({ ...d, socials: { ...(d.socials || {}), [k]: v } }));

  const save = async () => {
    setSaving(true);
    try {
      const updated = await adminApi.contact.put(data);
      setData(updated);
      toast.success("Contact updated");
    } catch {
      toast.error("Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (!data) return <div className="glass rounded-2xl h-32 animate-pulse" />;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-cyan-300 mb-1">CMS</div>
          <h1 className="font-display text-3xl text-white font-medium">Contact Info</h1>
          <p className="text-slate-400 text-sm mt-1">Public contact details and social links.</p>
        </div>
        <button onClick={save} disabled={saving} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-cyan-400 to-violet-500 text-black text-sm font-medium disabled:opacity-70">
          {saving ? <><Loader2 size={14} className="animate-spin" /> Saving</> : <><Save size={14} /> Save</>}
        </button>
      </div>
      <Section title="Contact">
        <div className="grid sm:grid-cols-2 gap-3">
          <div><Label>Email</Label><TextInput value={data.email} onChange={(v) => set("email", v)} /></div>
          <div><Label>Phone</Label><TextInput value={data.phone} onChange={(v) => set("phone", v)} /></div>
          <div className="sm:col-span-2"><Label>Location</Label><TextInput value={data.location} onChange={(v) => set("location", v)} /></div>
        </div>
      </Section>
      <Section title="Social platforms">
        <div className="grid sm:grid-cols-2 gap-3">
          {["github", "linkedin", "twitter", "leetcode", "codeforces", "codechef", "youtube", "portfolio"].map((k) => (
            <div key={k}>
              <Label>{k}</Label>
              <TextInput value={data.socials?.[k] || ""} onChange={(v) => setSocial(k, v)} placeholder={`https://${k}.com/...`} />
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
};

export default ContactInfo;
